import { motion } from "framer-motion";
import { Link } from "wouter";
import { Calendar, User } from "lucide-react";

interface BlogCardProps {
  title: string;
  summary: string;
  slug: string;
  date: string;
  author: string;
  image: string;
  category: string;
}

export default function BlogCard({ title, summary, slug, date, author, image, category }: BlogCardProps) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      whileHover={{ y: -5 }}
      transition={{ duration: 0.3 }}
      className="glass-effect rounded-xl overflow-hidden group"
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-4 left-4">
          <span className="px-3 py-1 bg-primary text-primary-foreground text-sm rounded-full">
            {category}
          </span>
        </div>
      </div>
      
      <div className="p-6">
        <div className="flex items-center space-x-4 text-sm text-muted-foreground mb-3">
          <div className="flex items-center space-x-1">
            <Calendar className="h-4 w-4" />
            <span>{new Date(date).toLocaleDateString()}</span>
          </div>
          <div className="flex items-center space-x-1">
            <User className="h-4 w-4" />
            <span>{author}</span>
          </div>
        </div>
        
        <h3 className="font-orbitron font-semibold text-lg mb-3 group-hover:text-primary transition-colors">
          {title}
        </h3>
        
        <p className="text-muted-foreground mb-4 line-clamp-3">
          {summary}
        </p>
        
        <Link href={`/blog/${slug}`} className="text-primary hover:text-secondary transition-colors font-semibold">
          Read More →
        </Link>
      </div>
    </motion.article>
  );
}
